"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CustomerNotes {
    constructor(noteRepository) {
        this.getCustomerNote = async (_token, customerId) => {
            return this.noteRepository.getNote(customerId);
        };
        this.setCustomerNote = async (_token, customerId, note) => {
            return this.noteRepository.setNote(customerId, {
                body: note,
            });
        };
        this.noteRepository = noteRepository;
    }
}
exports.default = CustomerNotes;
//# sourceMappingURL=CustomerNotes.js.map